<template lang="pug">
div
  v-tabs.mt-4(v-model="currentTabIndex", dark, background-color="primary")
    v-tab(v-for="{ tab: { key, label } } in tabs", :key="key") {{ label }}
  v-tabs-items(v-model="currentTabIndex")
    v-tab-item(v-for="{ item: { key, component } } in tabs", :key="key")
      component(:is="component")
</template>

<script>
import Details from "./Details";
// import Users from "./Users";

export default {
  name: "company-profile",

  data: () => ({
    currentTabIndex: 0,
  }),

  computed: {
    views() {
      return [
        { label: "Details", component: Details },
        // { label: "Users", component: Users },
      ];
    },

    tabs() {
      return this.views.map(({ label, component }, i) => ({
        tab: {
          key: "tab:" + i,
          label,
        },
        item: {
          key: "item:" + i,
          component,
        },
      }));
    },
  },
};
</script>